<template>
    <div class="textbox focus">
        <slot></slot>
    </div>
</template>

<script src="./mvt-textbox.js"></script>

<style lang="scss">
@use "./mvt-textbox.scss" as *;
</style>
